import gql from 'graphql-tag'

export const UserProfileFragment = gql`
	fragment UserProfileFragment on Profile {
		id
		aboutMe
		email
		firstName
		lastName
		hasAvatar
		avatarPath
		hasCover
		coverPath
		cvFilePath
		cvFileOriginalName
		featuredVideo
		company_name
		user {
			_OwnerToCompanyCollection {
				edges {
					node {
						company {
							id
							hasLogo
							name
							slug
							logoPath
						}
					}
				}
			}
		}
		# worksAt {
		# 	id
		# 	company
		# 	position
		# } // tiwari from sql
		_ProfileToValueCollection {
			edges {
				node {
					value {
						id
						title
					}
				}
			}
		}
		_ProfileToSkillCollection {
			edges {
				node {
					skill {
						id
						title
					}
				}
			}
		}
		experienceCollection {
			edges {
				node {
					id
					position
					company
					startDate
					roLocations {
						id
						type
						name
						region2
					}
					endDate
					isCurrent
					isPresent
					title
					description
				}
			}
		}
		user {
			id
			email
		}
		userOnBoardingFormVisited
	}
`
// eslint-disable-next-line
{
	/*
	
	fragment UserProfile on Profile {
		id
		aboutMe
		email
		firstName
		lastName
		hasAvatar
		avatarPath
		hasCover
		coverPath
		cvFilePath
		cvFileOriginalName
		featuredVideo
		ownedCompanies {
			id
			hasLogo
			name
			slug
			logoPath
		}
		worksAt {
			id
			company
			position
		}
		values {
			id
			title
		}
		skills {
			id
			title
		}
		experience {
			id
			position
			company
			startDate
			location {
				id
				type
				name
				region2
			}
			endDate
			isCurrent
			isPresent
			title
			description
		}
		user {
			id
			email
		}
		userOnBoardingFormVisited
	}
	/////
	export const UserProfileFragment = gql`
	fragment Node on Profile {
		id
		aboutMe
		email
		firstName
		lastName
		hasAvatar
		avatarPath
		hasCover
		coverPath
		cvFilePath
		cvFileOriginalName
		featuredVideo
		user {_OwnerToCompanyCollection{edges{node{company{
			id
			hasLogo
			name
			slug
			logoPath
		}}}}}
		# worksAt {
		# 	id
		# 	company
		# 	position
		# } // tiwari from sql
		# values {
		# 	id
		# 	title
		# }
		# skills {
		# 	id
		# 	title
		# }
		experienceCollection{edges{ node{
			id
			position
			company
			startDate
			roLocations {
				id
				type
				name
				region2
			}
			endDate
			isCurrent
			isPresent
			title
			description
		}}}
		user {edges{node{
			id
			email
		}}}
		userOnBoardingFormVisited
	}
`*/
}
// export const UserProfileArticlesFragment = gql`
// 	fragment UserProfileArticles on ProfileConnection {
// 		id
// 		# featuredArticles {
// 		# 	id
// 		# 	title
// 		# 	slug
// 		# 	body
// 		# 	description
// 		# 	readDuration
// 		# 	isPost
// 		# 	image {
// 		# 		id
// 		# 		filename
// 		# 	}
// 		# 	featuredVideo
// 		# }
// 	}
// `
